<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jJbrim/images/cover.jpg?1696786155647" alt="This image is the cover for the book Wicked Springfield, Wicked"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wicked Springfield, Wicked
      </h1>
      <p class="bookDescription body article font2">
        <p>In the twenty-four years that Abraham Lincoln lived in Springfield, the city saw its share of crime, corruption and scandal, much of it at the hands of Lincoln's law clients and acquaintances. Erika Holst sheds light on these shady characters, from the man being sued for divorce who claimed that he caught his venereal disease from an outhouse to Governor William Bissell, whose near duel with Jefferson Davis almost made him ineligible to hold office. Learn what prompted a congressional candidate- in an election clerked by Lincoln- to shout down his accuser as some 'spindle-shanked, toad-eating, man-granny, who feeds the depraved appetites of his patrons with gossip and slander.' Read the true stories that fed those depraved appetites, drawn from the newspapers Lincoln read and the docket where he practiced law. In these pages, discover the wicked side of Lincoln's Springfield.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erika Holst
      </h2>
      
      <p class="authorDescription body article">Erika Holst holds a master's degree from the Winterthur Program in Early American Culture. She has volunteered, interned and worked at museums and history projects throughout Illinois, including the David Davis Mansion State Historic Site in Bloomington, the McLean County Museum of History in Bloomington, the Cuneo Museum in Vernon Hills, Dickson Mounds Museum in Lewistown, the Papers of Abraham Lincoln, the Illinois State Museum and the Abraham Lincoln Presidential Library in Springfield.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6dca587d